import { defineComponent as L, useSlots as S, computed as n, createElementBlock as _, openBlock as r, mergeProps as $, unref as a, createVNode as F, createBlock as s, createCommentVNode as d, normalizeClass as g, withCtx as i, renderSlot as T, createTextVNode as B, toDisplayString as h } from "vue";
import u from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import { globalBreakpoints as N } from "./common.js";
import v from "./ToolbarGroup.vue2.js";
import b from "./ToolbarItem.vue2.js";
import P from "../Button.vue2.js";
import { useWindowSize as x } from "@vueuse/core";
import { useOUIAProps as I } from "../../helpers/ouia.js";
const V = ["hidden"], j = /* @__PURE__ */ L({
  name: "PfToolbarLabelGroupContent",
  __name: "ToolbarLabelGroupContent",
  props: {
    clearFiltersButtonText: { default: "Clear all filters" },
    collapseListedFiltersBreakpoint: { default: "lg" },
    numberOfFilters: { default: 0 },
    expanded: { type: Boolean },
    showClearFiltersButton: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["clear-all-filters", "mounted"],
  setup(k, { emit: C }) {
    const e = k, w = I({ id: e.ouiaId, safe: e.ouiaSafe }), f = C, y = S(), { width: O } = x(), o = n(() => e.collapseListedFiltersBreakpoint === "all" ? !0 : O.value < N[e.collapseListedFiltersBreakpoint]), m = n(() => o.value && e.numberOfFilters > 0 && !e.expanded), p = n(() => e.showClearFiltersButton && !e.expanded && !y.default);
    return (t, l) => (r(), _("div", $(a(w), {
      class: [a(u).toolbarContent, {
        [a(u).modifiers.hidden]: t.numberOfFilters === 0 || t.expanded
      }],
      hidden: t.numberOfFilters === 0 || t.expanded
    }), [
      F(v, {
        class: g({ [a(u).modifiers.hidden]: o.value }),
        hidden: o.value,
        "aria-hidden": o.value,
        onMounted: l[0] || (l[0] = (c) => f("mounted", c))
      }, null, 8, ["class", "hidden", "aria-hidden"]),
      m.value || p.value || t.$slots.default ? (r(), s(v, {
        key: 0,
        variant: "action-group-inline"
      }, {
        default: i(() => [
          m.value ? (r(), s(b, { key: 0 }, {
            default: i(() => [
              B(h(t.numberOfFilters) + " filters applied", 1)
            ]),
            _: 1
          })) : d("", !0),
          p.value ? (r(), s(b, { key: 1 }, {
            default: i(() => [
              F(P, {
                variant: "link",
                inline: "",
                onClick: l[1] || (l[1] = (c) => f("clear-all-filters"))
              }, {
                default: i(() => [
                  B(h(t.clearFiltersButtonText), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : d("", !0),
          T(t.$slots, "default")
        ]),
        _: 3
      })) : d("", !0)
    ], 16, V));
  }
});
export {
  j as default
};
